/* Breed datasets v2 - EXTENDS the food-calculator BREEDS object.
   Existing fields preserved exactly: n (name), lo/hi (ideal adult kg), mixed.
   NEW fields (both optional, used by the QUIZ to pre-fill chips):
     allergies: [] breed-prone protein/allergen tendencies (maps to quiz allergy chips)
     health:    [] breed-prone health-goal flags (maps to quiz health chips + safety tiers)

   IMPORTANT - DO NOT AUTO-SELECT (per owner instruction):
   The `health` and `allergies` arrays are reference predispositions ONLY.
   The quiz must NOT pre-tick health issues or allergies for the user - not
   every dog/cat of a breed actually has its breed-typical issues, and
   pre-ticking would wrongly imply the pet HAS the condition (also a
   compliance risk: no implied diagnosis). The USER selects health + allergies
   themselves (blank by default). Always keep an "Other" free-text option.
   By default the quiz uses ONLY the weight range (lo/hi) from this dataset.
   The health/allergies data is retained for optional non-committal soft hints
   (e.g. "joint support is popular for this breed") and future segmentation.

   health flag vocabulary (matches quiz health-goal chips):
     skin    = skin & coat sensitivity
     joints  = joint / mobility / hip-elbow tendency
     gut     = sensitive stomach / digestion
     weight  = prone to weight gain
     dental  = dental / small-jaw crowding
     brachy  = brachycephalic (flat-faced) - heat/breathing caution
   allergy vocabulary (matches quiz allergy chips):
     chicken, beef, lamb, fish, kangaroo, grain, dairy
   Sources: breed-health summaries from RSPCA, PetMD, Royal Canin breed guides,
   UK Kennel Club breed-health data, and APOP. General tendencies only.
*/
var BREEDS = {
  dog: [
    {n:"Affenpinscher",lo:3,hi:6,allergies:[],health:["dental"]},
    {n:"Airedale Terrier",lo:19,hi:30,allergies:["grain"],health:["skin"]},
    {n:"Akita",lo:33,hi:50,allergies:["chicken","grain"],health:["skin","joints"]},
    {n:"Alaskan Malamute",lo:32,hi:43,allergies:[],health:["joints","skin"]},
    {n:"American Bulldog",lo:27,hi:50,allergies:["grain"],health:["joints","skin"]},
    {n:"American Bully (Pocket)",lo:11,hi:32,allergies:["chicken","beef","grain"],health:["skin","joints"]},
    {n:"American Bully (Standard)",lo:30,hi:54,allergies:["chicken","beef","grain"],health:["skin","joints"]},
    {n:"American Bully (XL)",lo:32,hi:68,allergies:["chicken","beef","grain"],health:["skin","joints"]},
    {n:"American Staffordshire Terrier",lo:18,hi:30,allergies:["chicken","beef","grain"],health:["skin"]},
    {n:"Australian Cattle Dog",lo:15,hi:22,allergies:[],health:["joints"]},
    {n:"Australian Shepherd",lo:16,hi:32,allergies:[],health:["joints"]},
    {n:"Basset Hound",lo:20,hi:29,allergies:["grain"],health:["weight","joints","skin"]},
    {n:"Beagle",lo:9,hi:16,allergies:["chicken","grain"],health:["weight","skin","gut"]},
    {n:"Bernese Mountain Dog",lo:36,hi:50,allergies:[],health:["joints"]},
    {n:"Bichon Frise",lo:3,hi:5,allergies:["chicken","grain","dairy"],health:["skin","dental"]},
    {n:"Bloodhound",lo:36,hi:50,allergies:[],health:["joints","gut"]},
    {n:"Border Collie",lo:14,hi:20,allergies:[],health:["joints"]},
    {n:"Boston Terrier",lo:5,hi:11,allergies:["grain"],health:["brachy","skin","dental"]},
    {n:"Boxer",lo:22,hi:35,allergies:["chicken","beef","grain"],health:["skin","gut","brachy"]},
    {n:"British Bulldog",lo:18,hi:25,allergies:["chicken","grain"],health:["brachy","skin","joints","weight"]},
    {n:"Bull Terrier",lo:20,hi:32,allergies:["beef","dairy"],health:["skin"]},
    {n:"Cavalier King Charles Spaniel",lo:5,hi:8,allergies:[],health:["weight","dental"]},
    {n:"Chihuahua",lo:1.5,hi:3,allergies:["chicken"],health:["dental","weight"]},
    {n:"Chow Chow",lo:20,hi:32,allergies:["chicken","grain"],health:["skin","joints"]},
    {n:"Cocker Spaniel",lo:12,hi:16,allergies:["grain"],health:["skin","weight","dental"]},
    {n:"Collie (Rough/Border)",lo:14,hi:30,allergies:[],health:["joints"]},
    {n:"Dachshund (Miniature)",lo:3.5,hi:5,allergies:["grain"],health:["weight","dental","joints"]},
    {n:"Dachshund (Standard)",lo:8,hi:15,allergies:["grain"],health:["weight","joints"]},
    {n:"Dalmatian",lo:16,hi:32,allergies:["chicken","beef","grain"],health:["skin","gut"]},
    {n:"Doberman",lo:32,hi:45,allergies:[],health:["joints","skin"]},
    {n:"Dogue de Bordeaux",lo:54,hi:65,allergies:[],health:["joints","brachy","skin"]},
    {n:"English Springer Spaniel",lo:18,hi:25,allergies:["grain"],health:["skin","weight"]},
    {n:"French Bulldog",lo:8,hi:14,allergies:["chicken","beef","grain","dairy"],health:["brachy","skin","gut","joints"]},
    {n:"German Shepherd",lo:22,hi:40,allergies:["chicken","beef","grain"],health:["joints","gut","skin"]},
    {n:"German Shorthaired Pointer",lo:20,hi:32,allergies:[],health:["joints"]},
    {n:"Golden Retriever",lo:25,hi:34,allergies:["chicken","beef","grain"],health:["joints","skin","weight"]},
    {n:"Great Dane",lo:45,hi:80,allergies:[],health:["joints","gut"]},
    {n:"Greyhound",lo:26,hi:40,allergies:[],health:["dental"]},
    {n:"Groodle / Goldendoodle",lo:15,hi:35,allergies:["chicken","grain"],health:["joints","skin"]},
    {n:"Havanese",lo:3,hi:6,allergies:["grain"],health:["skin","dental"]},
    {n:"Hungarian Vizsla",lo:18,hi:30,allergies:[],health:["skin"]},
    {n:"Irish Setter",lo:24,hi:32,allergies:["grain"],health:["gut","skin"]},
    {n:"Irish Wolfhound",lo:47,hi:75,allergies:[],health:["joints"]},
    {n:"Jack Russell Terrier",lo:4,hi:7,allergies:[],health:["dental"]},
    {n:"Kelpie (Australian)",lo:14,hi:20,allergies:[],health:["joints"]},
    {n:"Labrador Retriever",lo:25,hi:36,allergies:["chicken","beef","grain"],health:["weight","joints","skin"]},
    {n:"Labradoodle",lo:12,hi:35,allergies:["chicken","grain"],health:["joints","skin"]},
    {n:"Maltese",lo:2.5,hi:4,allergies:["chicken","grain"],health:["dental","skin"]},
    {n:"Maltese Shih Tzu (Malshi)",lo:3,hi:6,allergies:["chicken","grain"],health:["dental","skin"]},
    {n:"Mastiff",lo:54,hi:100,allergies:[],health:["joints","brachy"]},
    {n:"Miniature Schnauzer",lo:5,hi:9,allergies:["fish"],health:["skin","weight"]},
    {n:"Newfoundland",lo:45,hi:70,allergies:[],health:["joints"]},
    {n:"Old English Sheepdog",lo:27,hi:45,allergies:["grain"],health:["joints","skin"]},
    {n:"Papillon",lo:3,hi:5,allergies:[],health:["dental"]},
    {n:"Pekingese",lo:3,hi:6.5,allergies:["grain"],health:["brachy","skin","dental"]},
    {n:"Pomeranian",lo:1.4,hi:3.2,allergies:["chicken"],health:["dental","skin"]},
    {n:"Poodle (Miniature)",lo:4.5,hi:7,allergies:["grain"],health:["dental","skin"]},
    {n:"Poodle (Standard)",lo:18,hi:32,allergies:["grain"],health:["joints","skin"]},
    {n:"Poodle (Toy)",lo:3,hi:6,allergies:["grain"],health:["dental","skin"]},
    {n:"Pug",lo:6,hi:9,allergies:["chicken","grain"],health:["brachy","weight","skin","dental"]},
    {n:"Rhodesian Ridgeback",lo:30,hi:41,allergies:[],health:["joints"]},
    {n:"Rottweiler",lo:35,hi:60,allergies:["grain"],health:["joints","weight"]},
    {n:"Saint Bernard",lo:50,hi:82,allergies:[],health:["joints","weight"]},
    {n:"Samoyed",lo:16,hi:30,allergies:[],health:["joints","skin"]},
    {n:"Schnauzer (Standard)",lo:14,hi:23,allergies:["fish"],health:["skin"]},
    {n:"Shar Pei",lo:18,hi:29,allergies:["chicken","beef","grain"],health:["skin","gut","brachy"]},
    {n:"Shetland Sheepdog",lo:7,hi:11,allergies:[],health:["skin","joints"]},
    {n:"Shih Tzu",lo:4,hi:7.5,allergies:["chicken","grain"],health:["brachy","skin","dental"]},
    {n:"Siberian Husky",lo:16,hi:27,allergies:["chicken","grain"],health:["skin"]},
    {n:"Spoodle / Cockapoo",lo:6,hi:16,allergies:["grain"],health:["skin","dental"]},
    {n:"Staffordshire Bull Terrier",lo:11,hi:17,allergies:["chicken","beef","grain"],health:["skin"]},
    {n:"Weimaraner",lo:25,hi:40,allergies:[],health:["gut","joints"]},
    {n:"Welsh Corgi (Pembroke)",lo:10,hi:14,allergies:[],health:["weight","joints"]},
    {n:"West Highland White Terrier",lo:6,hi:10,allergies:["grain","chicken"],health:["skin"]},
    {n:"Whippet",lo:9,hi:20,allergies:[],health:["dental"]},
    {n:"Yorkshire Terrier",lo:1.8,hi:3.2,allergies:["chicken","grain"],health:["dental","gut","skin"]},
    /* Mixed-breed size buckets - no breed-specific predispositions pre-ticked */
    {n:"Mixed breed - Small (up to 10kg)",lo:4,hi:10,mixed:true,allergies:[],health:[]},
    {n:"Mixed breed - Medium (10–25kg)",lo:10,hi:25,mixed:true,allergies:[],health:[]},
    {n:"Mixed breed - Large (25–45kg)",lo:25,hi:45,mixed:true,allergies:[],health:[]},
    {n:"Mixed breed - Giant (45kg+)",lo:45,hi:70,mixed:true,allergies:[],health:[]}
  ],
  cat: [
    {n:"Abyssinian",lo:2.7,hi:4.5,allergies:[],health:["dental"]},
    {n:"American Shorthair",lo:3.5,hi:7,allergies:[],health:["weight"]},
    {n:"Bengal",lo:3.5,hi:7,allergies:["grain"],health:["gut"]},
    {n:"British Shorthair",lo:4,hi:8,allergies:[],health:["weight"]},
    {n:"Burmese",lo:3,hi:6,allergies:[],health:["weight","dental"]},
    {n:"Devon Rex",lo:2.5,hi:4.5,allergies:[],health:["skin"]},
    {n:"Domestic Longhair",lo:3.5,hi:6,allergies:[],health:["weight"]},
    {n:"Domestic Shorthair",lo:3.5,hi:5.5,allergies:[],health:["weight"]},
    {n:"Exotic Shorthair",lo:3.5,hi:6.5,allergies:[],health:["brachy","weight","dental"]},
    {n:"Maine Coon",lo:4.5,hi:11,allergies:[],health:["joints","weight"]},
    {n:"Manx",lo:3.5,hi:5.5,allergies:[],health:["weight"]},
    {n:"Norwegian Forest Cat",lo:4,hi:9,allergies:[],health:["weight"]},
    {n:"Oriental Shorthair",lo:3,hi:5.5,allergies:[],health:["dental","gut"]},
    {n:"Persian",lo:3,hi:6.5,allergies:["grain"],health:["brachy","skin","dental"]},
    {n:"Ragdoll",lo:4.5,hi:9,allergies:[],health:["weight"]},
    {n:"Russian Blue",lo:3,hi:5.5,allergies:[],health:["weight"]},
    {n:"Savannah",lo:5.5,hi:11,allergies:[],health:["gut"]},
    {n:"Scottish Fold",lo:2.7,hi:6,allergies:[],health:["joints"]},
    {n:"Siamese",lo:2.5,hi:5.5,allergies:["fish"],health:["dental","gut"]},
    {n:"Siberian",lo:4.5,hi:9,allergies:[],health:["weight"]},
    {n:"Sphynx",lo:3,hi:5,allergies:[],health:["skin","gut"]},
    /* Mixed-breed size buckets (cats) - no predispositions pre-ticked */
    {n:"Mixed breed - Small (up to 4kg)",lo:2.5,hi:4,mixed:true,allergies:[],health:[]},
    {n:"Mixed breed - Medium (4–6kg)",lo:4,hi:6,mixed:true,allergies:[],health:[]},
    {n:"Mixed breed - Large (6kg+)",lo:6,hi:9,mixed:true,allergies:[],health:[]}
  ]
};

/* Quiz helper: given species + breed name, return the breed's data.
   NOTE: `allergies` and `health` here are REFERENCE ONLY - do NOT pre-tick them
   in the UI. By default the quiz should use only weightLo/weightHi to default
   the weight field. health/allergies are exposed for optional soft hints. */
function breedLookup(species, breedName){
  var list = (BREEDS[species] || []);
  for (var i=0;i<list.length;i++){
    if (list[i].n === breedName){
      return {
        weightLo:  list[i].lo,
        weightHi:  list[i].hi,
        // reference only - NOT for auto-selecting chips:
        _refAllergies: (list[i].allergies || []).slice(),
        _refHealth:    (list[i].health || []).slice()
      };
    }
  }
  return {weightLo:null, weightHi:null, _refAllergies:[], _refHealth:[]};
}
